function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Circle, {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M12.216 10.954a6.597 6.597 0 00-1.933 4.915 6.67 6.67 0 001.96 4.521c2.618 2.613 6.839 2.625 9.44.024a6.616 6.616 0 001.939-4.491c.188-6.008-7.145-9.225-11.406-4.97zm10.176 4.929a5.383 5.383 0 01-1.551 3.6l-.025.021c-2.125 2.131-5.591 2.122-7.731-.022a5.479 5.479 0 01-1.607-3.862 5.399 5.399 0 011.557-3.823l.022-.025c3.424-3.434 9.32-.947 9.341 3.886 0 .075 0 .15-.006.226z",
  fill: "#7057FF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#7057FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.84,
  d: "M14.239 15.735h5.25m-2.487-2.834v5.25"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#7057FF",
  strokeLinecap: "round",
  strokeWidth: 1.4,
  d: "M21.514 20.464l6.336 4.986"
}));

function SvgIconZoomPlus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _ref);
}

export default SvgIconZoomPlus;